import contract_subject_type from "dictionaries/contract_subject_type.json";
import createOptions from "utils/createOptions";

export default createOptions(contract_subject_type);
